/**
 * Created by Jan on 20.10.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ActionHandlers;

    (function (ActionHandlers, $, undefined) {
        /**
         * @memberOf Lfl.ActionHandlers
         */
        Lfl.ActionHandlers.OnDragHandlers;

        (function (OnDragHandlers, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.ActionHandlers.OnDragHandlers, 'DragHandlingParameters')) {
                return;
            }


            /*
             |===========================================================================================================
             | Class definition
             |===========================================================================================================
             */

            /**
             * Allows for modification of certain aspects of the handler's behaviour.
             * @param {string} [appliesToAxis] Movement on what axis the drag handler handles. Values: x/y/both (corresponds to jQuery draggable
             * axis parameter)
             *
             * @memberOf Lfl.ActionHandlers.OnDragHandlers
             * @lends Lfl.ActionHandlers.OnDragHandlers.DragHandlingParameters
             * @constructor
             */
            Lfl.ActionHandlers.OnDragHandlers.DragHandlingParameters = function (appliesToAxis) {
                /*
                 |-------------------------------------------------------------------------------------------------------------------
                 | Construction
                 |-------------------------------------------------------------------------------------------------------------------
                 */
                
                if (typeof appliesToAxis === 'undefined') {
                    appliesToAxis = 'both';
                }

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                /**
                 *
                 * @returns {string} x/y/both according to the "axis" parameter of the jQuery Draggable plugin. 
                 */
                this.getAppliesToAxis = function() {
                    return appliesToAxis;
                };

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

            };
        }(ActionHandlers.OnDragHandlers = ActionHandlers.OnDragHandlers || {}, jQuery));
    }(Lfl.ActionHandlers = Lfl.ActionHandlers || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

